export default [
	'bedc:client:read:{clientId}',

	'bedc:client:lookup',
	'bedc:client:list',

	'bedc:client:search',

	'bedc:client:create',

	'bedc:client:update',
	'bedc:client:update:{clientId}/team/qaPerson',
	'bedc:client:update:{clientId}/team/teamLeader',

	'bedc:client:teams:create/defaultAssignee',

	'bedc:client:teams:create/defaultJobChatMember',
	'bedc:client:teams:create/salesPersonDropdown', // [ROME-4653]
	'bedc:client:teams:create/customerContactDropdown', // [ROME-5225]

	'bedc:client:teams:create/defaultTransactionQAPerson',
	'bedc:client:teams:create/defaultTransactionTeamLeader',
	'bedc:client:teams:create/defaultTransactionOwner',
	'bedc:client:teams:create/defaultTransactionChatMember',
	'bedc:client:teams:create/defaultTransactionStageAssignee/accountingReviewPreDesign',
	'bedc:client:teams:create/defaultTransactionStageAssignee/accountingReviewPreProduction',
	'bedc:client:teams:create/defaultTransactionStageAssignee/invoicingPreScheduleDelivery',
	'bedc:client:teams:create/defaultTransactionStageAssignee/invoicingPreDelivery',
	'bedc:client:teams:create/defaultTransactionStageAssignee/invoicingPostDelivery',
	'bedc:client:teams:create/defaultTransactionStageAssignee/production',
	'bedc:client:teams:create/defaultTransactionStageAssignee/delivery',
] as const;
